var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section is-size-7"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [(!_vm.isPreview && !_vm.isEmailCaseLog) ? _c('div', {
    staticClass: "card"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_vm._v("Total Count: "), _c('strong', [_vm._v(_vm._s(_vm.totalCount))])]), _vm._v(" "), (_vm.emailCasesArray.length) ? _c('div', {
    staticClass: "rowFullTable"
  }, [_c('table', {
    staticClass: "table table-fixed table-hover tableFixHeadBottom table-text-cente"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', {
    staticClass: "position-relative"
  }, [_vm._l((_vm.emailCasesArray), function(emailCase, index) {
    return _c('tr', [_c('td', [_c('button', {
      staticClass: "btn btn-link px-0",
      attrs: {
        "type": "button",
        "title": "View Email Case Log"
      },
      on: {
        "click": function($event) {
          _vm.showEmailCaseLog(emailCase.caseid)
        }
      }
    }, [_vm._v(_vm._s(emailCase.caseid))]), _vm._v(" "), _c('br'), (emailCase.isrepeatcount && emailCase.isrepeatcount.toLowerCase() === 'yes') ? _c('span', {
      class: {
        'tag is-warning': emailCase.isrepeatcount && emailCase.isrepeatcount.toLowerCase() === 'yes'
      }
    }, [_vm._v("RepeatEmail")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "media-body"
    }, [_c('b', [_vm._v("Assigned To : ")]), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(emailCase.assignedto))]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Created Date :")]), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm._f("dateFilter")(emailCase.createddate)))]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Last Modified By : ")]), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(emailCase.lastmodifiedby))]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Last Modified Date : ")]), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm._f("dateFilter")(emailCase.lastmodifieddate)))])])]), _vm._v(" "), _c('td', [_c('b', [_vm._v("From:")]), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("\n                  " + _vm._s(emailCase.fromid) + "\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Subject:")]), _vm._v(" "), _c('span', [(emailCase.subject && emailCase.subject && emailCase.subject.length <= 200) ? _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(emailCase.subject))]) : (emailCase.subject && emailCase.subject) ? _c('span', {
      staticClass: "text-muted"
    }, [_c('b-tooltip', {
      attrs: {
        "label": emailCase.subject,
        "multilined": ""
      }
    }, [_vm._v("\n                      " + _vm._s(emailCase.subject.substring(0, 200)) + " ...\n                    ")])], 1) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Originate Source:")]), _vm._v(" "), (emailCase.originatesource) ? _c('span', [(emailCase.originatesource.toLowerCase() === 'cbfeedbackemail') ? _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("\n                    CB\n                  ")]) : (emailCase.originatesource.toLowerCase() === 'feedbackemail') ? _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("\n                    Web\n                  ")]) : (emailCase.originatesource.toLowerCase() === 'needhelp') ? _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("\n                    Need Help\n                  ")]) : _vm._e()]) : _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(" CCEmail")])]), _vm._v(" "), _c('td', [_c('h6', [(emailCase.status == 'allocationpending') ? _c('span', {
      class: [emailCase.status == 'allocationpending' ? 'badge badge-warning is-capitalized' : '']
    }, [_vm._v(_vm._s(emailCase.status))]) : _vm._e(), _vm._v(" "), (emailCase.status == 'allocated') ? _c('span', {
      class: [emailCase.status == 'allocated' ? 'badge badge-danger is-capitalized' : '']
    }, [_vm._v(_vm._s(emailCase.status))]) : _vm._e(), _vm._v(" "), (emailCase.status == 'inprocess') ? _c('span', {
      class: [emailCase.status == 'inprocess' ? 'badge badge-info is-capitalized' : '']
    }, [_vm._v(_vm._s(emailCase.status))]) : _vm._e(), _vm._v(" "), (emailCase.status == 'Close') ? _c('span', {
      class: [emailCase.status == 'Close' ? 'badge badge-success is-capitalized' : '']
    }, [_vm._v(_vm._s(emailCase.status))]) : _vm._e(), _vm._v(" "), (emailCase.status == 'spam') ? _c('span', {
      class: [emailCase.status == 'spam' ? 'badge badge-secondary is-capitalized' : '']
    }, [_vm._v(_vm._s(emailCase.status))]) : _vm._e(), _vm._v(" "), (emailCase.status == 'trash') ? _c('span', {
      class: [emailCase.status == 'trash' ? 'badge badge-dark is-capitalized' : '']
    }, [_vm._v(_vm._s(emailCase.status))]) : _vm._e(), _vm._v(" "), (emailCase.status == 'followup') ? _c('span', {
      class: [emailCase.status == 'followup' ? 'badge badge-info is-capitalized' : '']
    }, [_vm._v(_vm._s(emailCase.status))]) : _vm._e()])]), _vm._v(" "), _c('td', [(emailCase && emailCase.isattachment && emailCase.isattachment.toLowerCase() === 'yes') ? _c('span', [_c('router-link', {
      attrs: {
        "to": {
          path: encodeURI('/emailattachment'),
          query: {
            inboxID: emailCase.inboxid,
            caseID: emailCase.caseid
          }
        },
        "id": "link",
        "title": "View Attachment",
        "target": "_blank"
      }
    }, [_c('a', [_c('button', {
      attrs: {
        "variant": "outline-primary"
      }
    }, [_c('i', {
      staticClass: "fa fa-paperclip"
    })])])])], 1) : _c('span', [_vm._v("\n                  No\n                ")])]), _vm._v(" "), _c('td', [_c('p', [_c('b-button', {
      attrs: {
        "variant": "outline-primary btn-sm",
        "title": "Email Preview"
      },
      on: {
        "click": function($event) {
          _vm.getEmailPreview(emailCase.caseid);
          _vm.isPreview = true
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })])], 1)])])
  }), _vm._v(" "), (_vm.emailCasesArray.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v("Records not found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', [(_vm.totalPages > 1) ? _c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.totalPages,
      "margin-pages": 3,
      "click-handler": _vm.getPaginationData,
      "prev-text": '⏮',
      "next-text": '⏭',
      "container-class": 'pagination',
      "page-class": 'page-item',
      "pageLinkClass": 'page-link-item'
    }
  }) : _vm._e()], 1)]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isPreview && !_vm.isEmailCaseLog) ? _c('div', {
    staticClass: "card"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "link"
    },
    on: {
      "click": function($event) {
        _vm.isPreview = false
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('b-table', {
    staticClass: "table-outline mb-0",
    attrs: {
      "sticky-header": "",
      "hover": "",
      "striped": "",
      "responsive": "sm",
      "outline": "",
      "fields": _vm.emailPreviewFields,
      "items": _vm.emailMessageArray,
      "head-variant": "default"
    },
    scopedSlots: _vm._u([{
      key: "show_details",
      fn: function(ref) {
        var detailsShowing = ref.detailsShowing;
        var item = ref.item;

        return [_c('b-btn', {
          on: {
            "click": function($event) {
              _vm.toggleDetails(item)
            }
          }
        }, [_vm._v(_vm._s(detailsShowing ? 'Hide' : 'Show'))])]
      }
    }, {
      key: "row-details",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "card-body"
        }, [_c('div', {
          staticClass: "row mb-4"
        }, [_c('div', {
          staticClass: "col-sm-4"
        }, [_c('div', [_c('b', [_vm._v("Email From :")]), _vm._v("\n                    " + _vm._s(item.fromid) + "\n                  ")])])]), _vm._v(" "), _c('div', {
          staticClass: "row mb-4"
        }, [_c('div', {
          staticClass: "col-sm-4"
        }, [_c('div', [_c('b', [_vm._v("Email To :")]), _vm._v("\n                    " + _vm._s(item.toid) + "\n                  ")])])]), _vm._v(" "), _c('div', {
          staticClass: "row mb-4"
        }, [_c('div', {
          staticClass: "col-sm-4"
        }, [_c('div', [_c('b', [_vm._v("Email CC :")]), _vm._v("\n                    " + _vm._s(item.cc) + "\n                  ")])])]), _vm._v(" "), _c('div', {
          staticClass: "row mb-4"
        }, [_c('div', {
          staticClass: "col-sm-4"
        }, [_c('b', [_vm._v("Email Subject :")]), _vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(item.subject)
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "row mb-8"
        }, [_c('div', {
          staticClass: "col-sm-8"
        }, [_c('b', [_vm._v("Email Body :")]), _vm._v(" "), _c('span', {
          staticClass: "test",
          domProps: {
            "innerHTML": _vm._s(item.emailbody)
          }
        })])])])]
      }
    }, {
      key: "emaildate",
      fn: function(item) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("formatDate")(item.value)))])]
      }
    }, {
      key: "emailtype",
      fn: function(item) {
        return [(item.value.toLowerCase() == 'in') ? _c('span', [_vm._v("Received")]) : _vm._e(), _vm._v(" "), (item.value.toLowerCase() == 'out') ? _c('span', [_vm._v("Sent")]) : _vm._e()]
      }
    }, {
      key: "isattachment",
      fn: function(item) {
        return [_c('span', [(item.item.emailtype === 'in' && item.value && item.value && item.value.toLowerCase() === 'yes') ? _c('span', [_c('router-link', {
          attrs: {
            "to": {
              path: encodeURI('/emailattachment'),
              query: {
                inboxID: item.item.inboxid,
                caseID: item.item.caseid
              }
            },
            "id": "link",
            "title": "View Attachment",
            "target": "_blank"
          }
        }, [_c('a', [_vm._v("View Attachment")])])], 1) : _vm._e(), _vm._v(" "), (item.item.emailtype === 'out' && item.value && item.value && item.value.toLowerCase() === 'yes') ? _c('span', [_c('router-link', {
          attrs: {
            "to": {
              path: encodeURI('/emailattachment'),
              query: {
                outboxID: item.item.id,
                caseID: item.item.caseid
              }
            },
            "id": "link",
            "title": "View Attachment",
            "target": "_blank"
          }
        }, [_c('a', [_vm._v("View Attachment")])])], 1) : _c('span', [_vm._v("\n                  no\n              ")])])]
      }
    }]),
    model: {
      value: (_vm.currentItems),
      callback: function($$v) {
        _vm.currentItems = $$v
      },
      expression: "currentItems"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEmailCaseLog && !_vm.isPreview) ? _c('div', {
    staticClass: "card"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "link"
    },
    on: {
      "click": function($event) {
        _vm.isEmailCaseLog = false
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), (_vm.emailCaseLog && _vm.emailCaseLog.length) ? _c('div', {
    staticClass: "rowFullTable"
  }, [_c('table', {
    staticClass: "table-outline mb-0 table table-fixed table-hover tableFixHeadBottom table-text-cente",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "sticky-header": "",
      "hover": "",
      "striped": "",
      "responsive": "sm",
      "outline": ""
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', {
    staticClass: "position-relative"
  }, [_vm._l((_vm.emailCaseLog), function(emailCase, index) {
    return _c('tr', [_c('td', [_c('span', [_vm._v(_vm._s(emailCase.caseid))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(emailCase.allocationtype || '-'))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(emailCase.createdby))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm._f("dateFilter")(emailCase.createddate)))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(emailCase.status))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(emailCase.comment))])])])
  }), _vm._v(" "), (!_vm.emailCaseLog || _vm.emailCaseLog.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v("Records not found")])]) : _vm._e()], 2)])]) : _vm._e()], 1) : _vm._e()])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "table-head"
  }, [_c('th', {
    staticClass: "row-ID"
  }, [_vm._v("CaseID")]), _vm._v(" "), _c('th', {
    staticClass: "row-Desc"
  }, [_vm._v("AssignTo")]), _vm._v(" "), _c('th', {
    staticClass: "row-incident-level"
  }, [_vm._v("EmailInfo")]), _vm._v(" "), _c('th', {
    staticClass: "row-Date"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "row-Date"
  }, [_vm._v("Attachment")]), _vm._v(" "), _c('th', {
    staticClass: "row-ID"
  }, [_vm._v("Preview")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "table-head",
    attrs: {
      "head-variant": "default"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Case ID")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "13%"
    }
  }, [_vm._v("Allocation Type")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Email Status")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Comment")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7016665a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/emailr/trackingemailtracking.vue
// module id = 859
// module chunks = 1